module.exports = __webpack_public_path__ + "images/common/oldMan.74f4096f.svg";